<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { useAttrs } from "vue";

const attrs = useAttrs();
</script>

<template>
  <div
    :class="
      twMerge(
        'h-full w-full animate-pulse rounded-lg border-2 bg-gray-200 dark:border-kekkle-dark-light dark:bg-kekkle-dark-light',
        attrs.class as string,
      )
    "
  />
</template>
